module.exports = __webpack_public_path__ + "static/media/captain_female.4d854cf5.png";